import { Encoding, MarkTransform, MarkType } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { EncodingHelpers } from '../..';
import { ChartTranslator } from '../chart-translator';
import { addMeasureValuesToSeries, clearTextChannel } from './translator-util';

export class Bar100Translator implements ChartTranslator {
  translateHighChartsToMuze(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    // Clear the text channel
    let translatedEncoding = clearTextChannel(encoding);
    if (translatedEncoding.marks.channel === '*') {
      return translatedEncoding;
    }

    // Set the transform to 100% stacked
    translatedEncoding = EncodingHelpers.updateMarkOptions(translatedEncoding, {
      type: MarkType.Bar,
      transform: MarkTransform.Stack100Percent,
      showStackSum: true,
    }).encoding;

    // If showValues, add Measure Values to the text channel
    if (format.showValues) {
      translatedEncoding = addMeasureValuesToSeries(translatedEncoding, 'text');
    }
    return translatedEncoding;
  }

  translateMuzeToHighCharts(encoding: Encoding): Encoding {
    encoding = clearTextChannel(encoding);
    return encoding;
  }

  formatRequiresEncodingUpdate(
    oldFormat: Readonly<ChartTypes.ChartFormat>,
    newFormat: Readonly<ChartTypes.ChartFormat>
  ): boolean {
    return oldFormat.showValues !== newFormat.showValues;
  }
}
